"use client";

import { useEffect, useState } from "react";
import { Wrapper } from "@/components/Wrapper";
import { LanguageSelector } from "@/components/LanguageSelector";
import { getSiteInfo } from "@/sites";
import { useTranslation } from "react-i18next";

export const FooterCopyright = () => {
  const { t } = useTranslation("layout");

  const { domainName } = getSiteInfo(process.env.NEXT_PUBLIC_DOMAIN);

  // prevent Hydration Error:
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setWindowSizeChange] = useState(false);

  useEffect(() => {
    setWindowSizeChange(true);
  }, []);

  return (
    <div className="footer__copyright">
      <Wrapper customClass="footer__wrapper-copyright">
        <div className="footer__copyright-content">
          <div className="footer__language-selector">
            <LanguageSelector
              fullWidth
              upperDropdown
              ariaLabel="Change site language"
              dataQa="footer-language-selector"
            />
          </div>
          <div className="footer__text-container">
            <div className="footer__text">{t("footer_copyright_text")} DENSO WAVE INCORPORATED</div>
            <div className="footer__text">
              © {new Date().getFullYear()} {domainName} {t("footer_footer_copyright_text_2")}
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};
